package com.essntl.features.country.ui.addeditcountry

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.country.domain.model.CountryModel

data class AddEditCountryState(
    val country: MutableState<CountryModel> = mutableStateOf(CountryModel.empty),
    val getCountry: State<CountryModel> = State(),
    val addEditCountry: State<CountryModel> = State(),
    val deleteCountry: State<Unit> = State(),
    val isEditEnabled: Boolean = false,

    // Country Count
    val getAreasCountryCount: State<Long> = State(),
)
